import { render, staticRenderFns } from "./template.vue?vue&type=template&id=363f17d0&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=363f17d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f17d0",
  null
  
)

export default component.exports